export interface CancellationReasonConfig {
  value: string;
  description: string;
}

export interface SenderReceiverSection {
  name: string;
  value: string;
  isBold: boolean;
}

export interface TransactionItems {
  name: string;
  value: string;
  sendCurrency?: string;
}

export interface TransactionData {
  sections: [
    {
      title: string;
      items: TransactionItems[];
    }
  ];
  transactionId: number | string;
  refNumber: number | string;
  queryRefNumber: number | string;
}

export interface SummarySectionData {
  sections: [
    {
      title: string;
      items: TransactionItems[];
    }
  ];
}

export interface RefundModalData {
  transactionId: number | string;
  refNumber: number | string;
  queryRefNumber: number | string;
  amountDetails: any;
  flowType: string;
}

export const cancelReasons: CancellationReasonConfig[] = [
  { value: 'NO_RCV_LOC', description: 'I couldn’t find a location' },
  { value: 'INCORRECT_AMT', description: 'I entered the wrong amount' },
  { value: 'CHANGE_MIND', description: 'I am no longer interested' },
  { value: 'DUP_TRAN', description: 'Duplicate Transaction' },
  { value: 'WRONG_CRNCY', description: 'I selected the wrong currency' },
  { value: 'WRONG_CNTRY', description: 'I selected the wrong country' },
  { value: 'WRONG_STATE', description: 'I selected the wrong state/province' },
  { value: 'TECH_PROB', description: 'I ran into issues at the location​' },
  { value: 'NO_PICKUP', description: 'I didn’t have time' },
  { value: 'PROB_AT_LOC', description: 'Agent didn’t have enough funds' },
  // { value: 'INCOR_PRSNL_IDENT_INFO', description: 'I entered the wrong identification details'}, // Tim: Removed temproarily for MAWX-3125
  // { value: 'OTHER', description: 'Other' }, // Tim: Removed temproarily for MAWX-3125
];

export type SelectedOption = { reason: { value: string } } | { reason: string };

export type SelectedSubOption =
  | { subReason: { value: string } }
  | { subReason: string };

//ToDo - Will delete all commented code here

// export const reasonCodes = {
//     "NL_NO_RCV_LOC": "I couldn’t find a location",
//     "INCORRECT_AMT": "I entered the wrong amount",
//     "CHANGE_MIND": "I am no longer interested",
//     "DUP_TRAN": "Duplicate Transaction",
//     "WRONG_CRNCY": "I selected the wrong currency",
//     "WRONG_CNTRY":  "I selected the wrong country",
//     "WRONG_STATE": "I selected the wrong state/province",
//     "TECH_PROB": 	"I ran into issues at the location​",
//     "NO_PICKUP": "I didn’t have time",
//     "PROB_AT_LOC": "Agent didn’t have enough funds",
//     "INCOR_PRSNL_IDENT_INFO": "I entered the wrong identification details",
//     "OTHER": "Other",
// };

// export const subReasonCodesObj = {
//   "LOC_CLOSED": "MoneyGram location was closed",
//   "LOC_NOT_THERE": "MoneyGram location was not there",
//   "LOC_OTH": "Other",
// }

export const subReasonCodes = [
  { value: 'LOC_CLOSED', description: 'MoneyGram location was closed' },
  { value: 'LOC_NOT_THERE', description: 'MoneyGram location was not there' },
  { value: 'LOC_OTH', description: 'Other' },
];

// export const reasonCodeLabels = {
//     "LOC_OTH_LABEL": "Tell us mor about what happened here",
//     "TECH_PROB_LABEL": "Please describe the problem you had at the location:",
//     "OTHER_LABEL": "Tell us more about your reason for cancelling",
// }

// export const reasonCodeTextError = {
//     "TEXT_BOX_MAX": "Maximum 500 charatcters",
//     "CHAR_OVER_LIMIT": "characters over limit",
//     "CHAR_REMAIN": "characters remaining",
// }
